import React from 'react';

import PreviewArea from '../shared/PreviewArea';
import useFilePreviewViewModel from '../../useFilePreviewViewModel';
import { IFilePreviewUnitProps } from '../../index';
import FilePreviewProblem from '../../../FilePreviewProblem';
import useFilePreviewMediaViewModel from '../shared/useFilePreviewMediaViewModel';

const FilePreviewVideo: React.FC<IFilePreviewUnitProps> = ({ file, isLoading, setIsLoading }) => {
  const { isSupported } = useFilePreviewMediaViewModel(file, setIsLoading);
  const { fileLink } = useFilePreviewViewModel({ file, isFileSupported: isSupported });

  return (
    <PreviewArea isLoading={isLoading}>
      {isSupported && fileLink ? (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video
          style={{ margin: '0 auto', display: 'block', height: 'calc(100% - 125px)' }}
          controls
          src={fileLink}
          onLoadedData={() => setIsLoading(false)}
        />
      ) : (
        <FilePreviewProblem file={file} />
      )}
    </PreviewArea>
  );
};

export default FilePreviewVideo;
